<template>
  <div class="right_body action_body">
    <span class="btn right_sub_btn save_btn" @click="submitData">提交数据</span>
    <div class="active_rumb">
      <span class="txt">工厂数据</span>
    </div>
    <el-form ref="baseForm" :rules="rules" :model="fromData">
      <div class="coll">
        <h2 class="title">
          <span>基本信息</span>
        </h2>
        <div class="from_box flex">
          <div class="item" v-if="isEdit">
            <span class="txt">工厂编码：</span>
            <el-input v-model="fromData.factoryCode" :disabled="isEdit" placeholder="请输入工厂编码"></el-input>
          </div>
          <div class="item">
            <span class="txt">工厂描述：</span>
            <el-input
              v-model="fromData.factoryDesc"
              maxlength="40"
              autocomplete="off"
              placeholder="请输入"
            ></el-input>
          </div>

          <el-form-item class="item" label="所属公司：" prop>
            <el-select
              v-model="fromData.companyId"
              @change="changeCompany"
              filterable
              :placeholder="$store.state.remark.companySelect"
            >
              <el-option
                v-for="item in companyList"
                :key="item.companyId"
                :label="item.value"
                :value="item.companyId"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- <div class="item">
							<span class="txt">供应商编号：</span>
							<el-input v-model="fromData.supplierCode" oninput="value=value.replace(/[^\d]/g,'')" autocomplete="off" placeholder="请输入"></el-input>
						</div>
						<div class="item">
							<span class="txt">供应商描述：</span>
							<el-input v-model="fromData.supplierDesc" autocomplete="off" placeholder="请输入"></el-input>
						</div>
						<div class="item">
							<span class="txt">公司编码：</span>
							<el-input v-model="fromData.companyCode" oninput="value=value.replace(/[^\d]/g,'')" autocomplete="off" placeholder="请输入"></el-input>
						</div>
						<div class="item">
							<span class="txt">公司描述：</span>
							<el-input v-model="fromData.companyDesc" autocomplete="off" placeholder="请输入"></el-input>
						</div>
						<div class="item">
							<span class="txt">客户号：</span>
							<el-input v-model="fromData.customerCode" oninput="value=value.replace(/[^\d]/g,'')" autocomplete="off" placeholder="请输入"></el-input>
						</div>
						<div class="item">
							<span class="txt">客户描述：</span>
							<el-input v-model="fromData.customerDesc" autocomplete="off" placeholder="请输入"></el-input>
          </div>-->
        </div>
      </div>
      <div class="coll">
        <h2 class="title">
          <span>联系信息</span>
        </h2>
        <div class="from_box flex">
          <el-form-item class="item" label="电子邮件：" prop="email">
            <el-input type="text" :placeholder="$store.state.remark.email" v-model="fromData.email"></el-input>
          </el-form-item>
          <el-form-item class="item" label="联系电话：" prop="telephone">
            <el-input
              type="text"
              :placeholder="$store.state.remark.mob"
              v-model="fromData.telephone"
            ></el-input>
          </el-form-item>
        </div>
      </div>

      <div class="coll">
        <h2 class="title">
          <span>地址</span>
        </h2>
        <div class="from_box flex">
          <div class="item">
            <span class="txt">国家代码：</span>
            <el-select
              filterable
              @change="changContryKeyValue"
              v-model="fromData.contryKeyValue"
              placeholder="请选择"
            >
              <el-option
                v-for="(item,index) in cities"
                :key="item.index"
                :label="item.zh"
                :value="item.locale"
              >
                <span style="float: left">{{ item.locale}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.zh}}</span>
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <span class="txt">所在地区：</span>
            <el-input v-model="fromData.area" autocomplete="off" placeholder="请输入"></el-input>
          </div>
          <div class="item">
            <span class="txt">详细地址：</span>
            <el-input
              v-model="fromData.streetOrAddress"
              autocomplete="off"
              placeholder="请输入"
            ></el-input>
          </div>
          <div class="item">
            <span class="txt">邮编：</span>
            <el-input
              v-model="fromData.zipCode"
              autocomplete="off"
              oninput="value=value.replace(/[^\d]/g,'')"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
      </div>
      <!-- <div class="coll">
					<h2 class="title"><span>其他信息</span></h2>
					<div class="from_box flex">
						<div class="item">
							<span class="txt">增值税登记号：</span>
							<el-input v-model="fromData.no" oninput="value=value.replace(/[^\a-\z\A-\Z0-9]/g,'')" autocomplete="off" placeholder="请输入"></el-input>
						</div>
					</div>
      </div>-->
    </el-form>
  </div>
</template>

<script>
import { factoryApi } from "api/base.js";
import { company } from "api/system.js";
import countryCode from "mock/countryCode.json";
import areaJson from "mock/area.json";
import { mapState, mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      cities: countryCode,
      areaData: areaJson,
      id: "",
      isEdit: false,
      activeName: "base",
      selectArea: [],
      fromData: {
        contryKeyValue: "CN" //国家地区默认中国
      },
      rules: {
        email: [
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "请输入正确的邮箱格式",
            trigger: "blur"
          }
        ],
        telephone: [
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机格式",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.getCompany();
    this.getInfo();
    this.areaData.forEach((v, k) => {
      if (!v.children) {
        delete v.children;
      }
    });
    /* for(var i = 0; i < this.areaData.length; i++) {
			if(this.areaData[i].children.length < 1){
				delete this.areaData[i].children
			}
		} */
  },
  computed: {
    ...mapState("cache", ["companyList"])
  },
  methods: {
    ...mapActions("cache", ["setCompanyList"]),
    async getCompany() {
      if (!this.companyList) {
        let res = await this.$post(company.list, this.$store.state.getAllPage);
        if (res.status) {
          res.data.list.map(item => {
            return (item.value = item.companyCode + " - " + item.companyName);
          });
          this.setCompanyList(res.data.list);
        } else {
          this.setCompanyList(null);
        }
      }
      console.log(this.companyList, "== 请求回来的数据 ===");
    },
    //获取选中的值
    onProvincesChange(item) {
      let codeStr = this.$refs.myCascader.getCheckedNodes()[0].pathLabels;
      this.selectArea = item;
      codeStr.forEach((v, k) => {
        if (k === 0) {
          this.fromData.provinceDesc = v;
          this.fromData.provinceCode = item[k];
        } else if (k === 1) {
          this.fromData.cityDesc = v;
          this.fromData.cityCode = item[k];
        } else {
          this.fromData.countyDesc = v;
          this.fromData.countyCode = item[k];
        }
      });
    },
    //获取国家代码
    changContryKeyValue(item) {},
    handleClick(tab, event) {},
    //公司改变
    changeCompany(val) {
      this.fromData.companyId = val;
      let obj = this.companyList.find(v => v.companyId === val);
      if (obj) {
        this.fromData.companyCode = obj.companyCode;
        this.fromData.companyDesc = obj.companyName;
      }
    },
    //获取当前的数据
    async getInfo() {
      let id = this.$route.params.id;
      if (id) {
        this.isEdit = true;
        let res = await this.$get(factoryApi.find, { factoryId: id });
        const { data, msg, msgCode, code } = res;
        this.selectArea = [data.provinceCode, data.cityCode, data.countyCode];
        if (data) {
          this.fromData = data;
        }
      }
    },
    //提交数据
    async submitData() {
      let vm = this;
      let id = this.$route.params.id;
      var postUrl = factoryApi.add;
	  if (id) postUrl = factoryApi.edit;
	  if(!this.fromData.factoryDesc){ 
        this.$message.error('请选择工厂描述');
        return false;
      }
      if(!this.fromData.companyId){ 
        this.$message.error('请选择所属公司');
        return false;
      }
      if(!this.fromData.email){ 
        this.$message.error('请选择电子邮箱');
        return false;
      }
      if(!this.fromData.telephone){ 
        this.$message.error('请选择联系电话');
        return false;
	  }
	  if(!this.fromData.area){ 
        this.$message.error('请选择所在地区');
        return false;
      }
      if(!this.fromData.streetOrAddress){ 
        this.$message.error('请选择详细地址');
        return false;
      }
      if(!this.fromData.zipCode){ 
        this.$message.error('请选择邮编');
        return false;
      }
      let res = await this.$post(postUrl, this.fromData);
      if (res.status) {
        let successMsg = id
          ? "工厂 " + res.data.factoryCode + " 修改成功"
          : "工厂" + res.data.factoryCode + "创建成功";
        this.$alert(successMsg, "操作提示", {
          confirmButtonText: "确定",
          callback: action => {
            vm.fromData = {};
            vm.$router.push({ name: "base-factory-list" });
          }
        });
        //清空工厂主数据
        this.$store.state.cache.factoryList = null;
      } else {
        this.$message.error(res.errorMsg);
      }
    }
  }
};
</script>

<style lang="stylus" scoped></style>
